import React, { useEffect, useRef } from "react";
import "./portfoliosection.css";
import AOS from "aos";
import "aos/dist/aos.css";

// Import your 6 videos
import video1 from "../../assets/portfoliovedio/one.mp4";
import video2 from "../../assets/portfoliovedio/two.mp4";
import video3 from "../../assets/portfoliovedio/three.mp4";
import video4 from "../../assets/portfoliovedio/four.mp4";
import video5 from "../../assets/portfoliovedio/five.mp4";
import video6 from "../../assets/portfoliovedio/six.mp4";

function PortfolioSection() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const portfolioRef = useRef(null);

  // Play video on hover, pause on mouse leave
  const handleMouseEnter = (e) => {
    e.target.play();
  };

  const handleMouseLeave = (e) => {
    e.target.pause();
    e.target.currentTime = 0; // rewind video
  };

  // Drag-to-scroll horizontally
  const handleDragScroll = (e) => {
    e.preventDefault();
    const slider = portfolioRef.current;
    let startX = e.pageX - slider.offsetLeft;
    let scrollLeft = slider.scrollLeft;

    const mouseMoveHandler = (e) => {
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2; // scroll speed multiplier
      slider.scrollLeft = scrollLeft - walk;
    };

    const mouseUpHandler = () => {
      window.removeEventListener("mousemove", mouseMoveHandler);
      window.removeEventListener("mouseup", mouseUpHandler);
    };

    window.addEventListener("mousemove", mouseMoveHandler);
    window.addEventListener("mouseup", mouseUpHandler);
  };

  const videos = [video1, video6,video2, video3, video4, video5, ];

  return (
    <section className="portfolio-section">
      <div className="container">
        <section className="section-margin">
          <div className="heading-for-all"  data-aos="fade-up">
            <h2>Our Portfolio</h2>
          </div>
        </section>

        <div
          className="portfolio-grid"
          ref={portfolioRef}
          onMouseDown={handleDragScroll}
        >
          {videos.map((video, index) => (
            <div
              key={index}
              className="portfolio-card"
              data-aos="fade-up"
              data-aos-delay={index * 150}
            >
              <video
                src={video}
                muted
                loop
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                className="portfolio-video"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PortfolioSection;
